import dayjs from 'dayjs'
import dayjsBusinessDays from 'dayjs-business-days2'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isToday from 'dayjs/plugin/isToday'
import dayjsUtc from 'dayjs/plugin/utc'

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isToday)
dayjs.extend(customParseFormat)
dayjs.extend(dayjsBusinessDays)
dayjs.extend(dayjsUtc)

// Day utils

export const isTodaysDate = (date: Date | string) => dayjs(date).isToday()

export const getTodaysDate = () => dayjs().toISOString()

export const getEndOfDay = (date: Date | string, utc = false) => {
  const day = utc ? dayjs(date).utc() : dayjs(date)
  return day.endOf('day').toISOString()
}

export const getStartOfDay = (date: Date | string, utc = false) => {
  const day = utc ? dayjs(date).utc() : dayjs(date)
  return day.startOf('day').toISOString()
}

export const isSameDate = (date1: Date | string, date2: Date | string) => dayjs(date1).isSame(date2)

export const isSameDay = (date1: Date | string, date2: Date | string) =>
  dayjs(date1).isSame(date2, 'day')

export const isBeforeDay = (date1: Date | string, date2: Date | string) =>
  dayjs(date1).isBefore(date2, 'day')

export const isSameOrBeforeDay = (date1: Date | string, date2: Date | string) =>
  dayjs(date1).isSameOrBefore(date2, 'day')

export const isAfterDay = (date1: Date | string, date2: Date | string) =>
  dayjs(date1).isAfter(date2, 'day')

export const isSameOrAfterDay = (date1: Date | string, date2: Date | string) =>
  dayjs(date1).isSameOrAfter(date2, 'day')

export const getDateXDaysBefore = (date: Date | string, days: number) =>
  dayjs(date).subtract(days, 'day').toISOString()

export const getDateXDaysAfter = (date: Date | string, days: number) =>
  dayjs(date).add(days, 'day').toISOString()

export const exceedsMaxDaysRange = (from: Date | string, to: Date | string, days: number) => {
  const diffDays = dayjs(from).diff(to, 'day')
  return Math.abs(diffDays) > days
}

// Month utils

export const getFirstDayOfCurrentMonth = () => dayjs().date(1).toISOString()

export const isSameMonth = (date1: Date | string, date2: Date | string) =>
  dayjs(date1).isSame(date2, 'month')

// General

export const isValid = (date: Date | string) => dayjs(date).isValid()

export const isBefore = (date1: Date | string, date2: Date | string) => dayjs(date1).isBefore(date2)

export const getDiff = (date1: Date | string, date2: Date | string) =>
  Math.abs(dayjs(date1).diff(date2)) // milliseconds

export const format = (date: Date | string, formatTemplate: string) =>
  dayjs(date).format(formatTemplate)

/* Checks if the html date input is supported by the browser */
export const checkDateInputSupported = () => {
  // Create new input element
  const elem = window.document.createElement('input')

  // Set the type attribute
  elem.setAttribute('type', 'date')

  // Set an invalid value
  const invalidValue = 'not-a-valid-date'
  elem.setAttribute('value', invalidValue)

  return elem.value !== invalidValue
}

// Business days

export const addBusinessDays = (date: Date | string, days: number) =>
  dayjs(date).businessDaysAdd(days).toISOString()
